import React from "react";
import PolicyActivationComponent from "@components/PolicyActivation";

export default function PolicyActivation() {
  return <PolicyActivationComponent />;
}
